import { add } from "src/shared/helpers/calculator"
import { DefaultValuesType } from "../VentaHabitacion.types"
import { DesgloseTarifa } from "../../../shared/hooks/useMotorTarifas/useMotorTarifas.type"

type UseGetUpdateParams = {
    total: number
    subtotal: number
    total_experiencias: number
    total_reservas: number
    total_tarifas: number
    desglose_tarifas: DesgloseTarifa[]
    costo_early_check_in: number
}

export function useCosts() {
    const getUpdateCosts = ({ total, total_experiencias, total_reservas, total_tarifas, desglose_tarifas, costo_early_check_in, subtotal = 0 }: UseGetUpdateParams): DefaultValuesType["costs"] => {
        const costos = {
            room: 0,
            users: 0,
            hours: 0,
            hospedajes: 0,
            costoEarlyCheckIn: costo_early_check_in,
            tax: 0,
            total: subtotal,
            general: total,
        }

        desglose_tarifas.forEach((d)=>{
            costos.room = add(costos.room, d.subtotal_hospedaje || 0)
            costos.users = add(costos.users, d.subtotal_personas_extra || 0)
            costos.hours = add(costos.hours, d.subtotal_horas_extra || 0),
            costos.hospedajes = add(costos.hospedajes, d.subtotal_hospedajes_extra || 0)
        })

        return costos
    }


    return {
        getUpdateCosts
    }
}